import { useCallback, useState } from 'react';

const useDiarySections = () => {
    const [openSections, setOpenSections] = useState({});

    const toggleSection = useCallback((key) => {
        setOpenSections((prev) => ({
            ...prev,
            [key]: !prev[key]
        }));
    }, []);

    const closeSection = useCallback((key) => {
        setOpenSections((prev) => ({
            ...prev,
            [key]: false
        }));
    }, []);

    return { openSections, toggleSection, closeSection };
};

export default useDiarySections;
